import { MALDIVES_CHARTER_SEARCH_PAGE_MAX_CHECK_IN_DATE } from 'constants/charterFlight'

/** YYYY-MM month key for the last month the Maldives search banner may show. */
const MALDIVES_BANNER_MAX_ELIGIBLE_MONTH = MALDIVES_CHARTER_SEARCH_PAGE_MAX_CHECK_IN_DATE.slice(0, 7)

interface Options {
  checkIn?: string
  flexibleMonths?: string
}

/**
 * Whether the Maldives hotel-search marketing banner should show for the
 * selected travel dates. Eligible when check-in or any flexible month is on or
 * before 16 November 2027. Anytime (no dates) remains eligible.
 */
export function isMaldivesBannerSearchDateEligible({
  checkIn,
  flexibleMonths,
}: Options): boolean {
  if (checkIn) {
    return checkIn <= MALDIVES_CHARTER_SEARCH_PAGE_MAX_CHECK_IN_DATE
  }

  if (flexibleMonths) {
    const months = flexibleMonths.split(',').map(month => month.trim()).filter(Boolean)
    if (months.length === 0) return true
    return months.some(month => month <= MALDIVES_BANNER_MAX_ELIGIBLE_MONTH)
  }

  return true
}
